require('intersection-observer');

// Responsive Background images
// ----------------------------

const body = document.body;
const inBackend = body.classList.contains('neos-backend');

const intersectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        let element = entry.target;
        let img = element.querySelector('img');
        let computedStyle = window.getComputedStyle(element);
        let src = computedStyle.getPropertyValue('background-image').replace(/url\(['"]?(.*?)['"]?\)/i, '$1');

        function update() {
            let newSrc = img.currentSrc || img.src;
            if (newSrc !== src) {
                src = newSrc;
                element.style.backgroundImage = `url("${src}")`;
                element.classList.add('ready');
            }
            observer.unobserve(element);
        }

        if (entry.isIntersecting) {
            img.complete ? update() : img.addEventListener('load', update);
        }
    });
}, {
    rootMargin: '100px'
});

function responsiveBackgroundImage(element) {
    const img = element.querySelector('img');

    if (!img) {
        return;
    }

    intersectionObserver.observe(element);
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('[data-responsive-background-image]');
    elements.forEach(responsiveBackgroundImage);

    if (inBackend) {
        document.addEventListener('Neos.NodeSelected', (event) => {
            // Re-apply responsive images when node changed/selected
            const selectedElement = event.detail.element;
            if (selectedElement && selectedElement.hasAttribute('data-responsive-background-image')) {
                responsiveBackgroundImage(selectedElement);
            }
        });
    }
});
